import frame from "../../../assets/mobile_frame.svg";
import { useIsTesting } from "@yuno/dashboard-container-mfe";
import styled from "@emotion/styled";

export const Mobile = () => {
  const { isTesting } = useIsTesting();

  // Temporal
  return (
    <img
      src={frame}
      style={{
        marginTop: "-40px",
        minHeight: "130%",
        maxWidth: "457px",
        objectFit: "fill",
        marginBottom: "40px",
      }}
    />
  );
};
